import { Asset } from 'common/models'

import { SharedEventView } from './shared-event-view'

export const SwitchEventView = ({ assets }: Props) => {
  return <SharedEventView assets={assets} />
}

type Props = {
  assets: Asset[]
}
